import { render } from "./ToBankDetailsPaymentDetails.vue?vue&type=template&id=bd3e14f0&scoped=true&ts=true"
import script from "./ToBankDetailsPaymentDetails.vue?vue&type=script&lang=ts"
export * from "./ToBankDetailsPaymentDetails.vue?vue&type=script&lang=ts"

import "./ToBankDetailsPaymentDetails.vue?vue&type=style&index=0&id=bd3e14f0&scoped=true&lang=css"

import exportComponent from "/app/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bd3e14f0"]])

export default __exports__